export default "__VITE_ASSET__BnK9Y_pE__"